import { SET_PARTICIPANT_DATA } from "../../ActionTypes/Event/participantActionTypes";

const initialState = {

};

const participantData = (state = initialState, action: any) => {

  switch (action.type) {
    case SET_PARTICIPANT_DATA:
      return {
        ...state,
        ...action.payload
      };
    default:
      return state;
  }
};

export default participantData;

